<template>
  <div id="footerBar">
    <div class="footer_products">
      <a v-for="(item, index) in productLists" :key="index" :href="item.href">{{item.text}}</a>
    </div>
    <p class="footer_version">©{{year}}网易公司 <router-link tag="a" :to="{ path: '/clause', query: { clause: 'policy' }}">隐私条款 </router-link> <router-link tag="a" :to="{ path: '/clause', query: { clause: 'search' }}">服务条款 </router-link> 京ICP证080268号 京公网安备 11010802020092号</p>
  </div>
</template>

<script>
export default {
  name: "TabBar",
  data() {
    return {
      year: new Date().getFullYear(),
      productLists: [
        {
          text: '有道首页',
          href: 'https://www.youdao.com/?keyfrom=fanyi-new.copyright'
        },
        {
          text: '有道词典',
          href: 'https://cidian.youdao.com/mobile.html'
        },
        {
          text: '有道智选',
          href: 'https://dsp.youdao.com/?keyfrom=about.youdao#/index'
        },
        {
          text: '有道智云',
          href: 'https://ai.youdao.com/?keyfrom=dict2.index'
        },
        {
          text: '关于有道',
          href: 'https://shared.ydstatic.com/www/about.html?keyfrom=dict2.index'
        },
        {
          text: '官方博客',
          href: 'https://i.youdao.com/'
        }
      ]
    }
  },
};
</script>

<style scoped>
#footerBar {
  width: 100%;
  height: 103px;
  box-sizing: border-box;
  background:rgba(246,246,249,1);
  padding-top: 30px;
  overflow: hidden;
}
.footer_products {
  height: 17px;
  overflow: hidden;
  margin: 0 auto;
  text-align: center;
  font-size: 0;
}
.footer_products a:first-child {
  padding: 0 12px 0 0;
}
.footer_products a:last-child {
  border: 0;
  padding: 0 0 0 12px;
}
.footer_products a {
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  color: rgba(164,164,164,1);
  line-height: 17px;
  vertical-align: top;
  display: inline-block;
  padding: 0 18px;
}
.footer_version {
  width: 100%;
  height: 17px;
  font-size: 12px;
  font-weight:600;
  color:rgba(188,188,188,1);
  line-height: 17px;
  text-align: center;
  margin-top: 9px;
}
.footer_version a {
  font-size: 12px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(146,146,151,1);
  line-height: 17px;
  font-style: normal;
}
.footer_version a:hover {
  color: #333333;
}
</style>
